import { deleteTransferApi } from "./deleteTransferApi";

export const deleteTransferSetData = async (
  lang,
  setMessageResponse,
  cookies,
  transferId,
  setSuccessMessage
) => {
  const response = await deleteTransferApi(transferId, lang, cookies);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      data: response.res.data,
    }));
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
